import { apiDelete } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

/**
 * 카테고리 삭제 API 함수 (soft delete - is_active를 false로 변경)
 * @param id 삭제할 카테고리의 ID
 * @returns API 응답 객체
 */
export const apiDeleteCategory = async (id: string) => {
  const response = await apiDelete<null>(`/categories/${id}`);
  return response.data;
};

/**
 * 카테고리 삭제 React Query 훅
 * @returns 뮤테이션 객체
 */
export const useDeleteCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => apiDeleteCategory(id),
    onSuccess: (_, id) => {
      // 카테고리 목록과 특정 카테고리 데이터 무효화
      queryClient.invalidateQueries({ queryKey: ["categories"] });
      queryClient.invalidateQueries({ queryKey: ["categories", id] });
    },
  });
};

export default useDeleteCategory;
